import {authRequest} from './index.js'


export async function get_reward_action(reward_action_tag){
  let data
  await authRequest.get(
    'reward_actions/' + reward_action_tag
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_reward_actions(){
  let data
  await authRequest.get(
    '/reward_actions'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_reward_action(reward_action){
  let data
  await authRequest.post(
    '/reward_actions',
    { reward_action },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_reward_action(reward_action_id){
  let data
  await authRequest.delete(
    '/reward_actions/' + reward_action_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_reward_action(reward_action_id, reward_action){
  let data
  await authRequest.patch(
    '/reward_actions/' + reward_action_id,
    { reward_action },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}